export const registerAnalyticsProperty = ({
  property,
  value,
}: {
  property: string;
  value: string | number;
}) => {
  document.dispatchEvent(
    new CustomEvent("sd-register-property", {
      detail: {
        property,
        value,
      },
    }),
  );
};
